export default __webpack_public_path__ + "static/media/26-membrane.5a4a0338.png";